import BasicInfromationForm from "./Form/BasicInfromationForm";
import ResearchBackgroundForm from "./Form/ResearchBackgroundForm";
import ResponseToTEForm from "./Form/ResponseToTEForm";
import ProgressReportForm from "./Form/ProgressReportForm";
import ProgressPPTForm from "./Form/ProgressPPTForm";
import PlanForRemainingQuarterForm from "./Form/PlanForRemainingQuarterForm";
import ProjectGanttChartForm from "./Form/ProjectGanttChartForm";
import SubmitForm from "./Form/SubmitForm";
import Show from "./Show";

const Qpr = {
  BasicInfromationForm,
  ResearchBackgroundForm,
  ResponseToTEForm,
  ProgressReportForm,
  ProgressPPTForm,
  PlanForRemainingQuarterForm,
  ProjectGanttChartForm,
  SubmitForm,
  Show
};

export default Qpr;